export enum Functionnalities {
    SIGNATURE = 'SIGNATURE',
}